// src/pages/layouts/DashboardLayout.jsx
import React from 'react'
import { Outlet } from 'react-router-dom'
import { Sidebar } from '../../widgets/Sidebar/Sidebar'
import { Header } from '../../widgets/Header/Header'
import { BottomBar } from '../../widgets/BottomBar/BottomBar'
import ChatWidget from '../../widgets/ChatWidget/ChatWidget'
import NoteTakerDrawer from 'widgets/NoteTaker/NoteTakerDrawer'
import NoteTakerShell from 'widgets/NoteTaker/NoteTakerShell'
import s from './styles/DashboardLayout.module.scss'
import useDashboardLayout from './hooks/useDashboardLayout'
import { HeaderActionsContext } from 'widgets/Header/context/headerActionsContext'

export const DashboardLayout = () => {
	const {
		currentPage,
		headerActions,
		headerLeading,
		setHeaderActions,
		setHeaderLeading,
		isApplicationDetailsPage,
		isStudentProfilePage,
		isMessagesPage,
	} = useDashboardLayout()
	const shouldShowHeader = Boolean(currentPage || headerActions || headerLeading)
	const isDetailsPage = isApplicationDetailsPage || isStudentProfilePage
	const isFullBleedPage = isDetailsPage || isMessagesPage
	return (
		<HeaderActionsContext.Provider value={{ setHeaderActions, setHeaderLeading }}>
			<div className={s.wrap}>
				<div className={s.sidebar}>
					<Sidebar />
				</div>

				<div className={s.inner}>
					{shouldShowHeader && (
						<Header
							page={currentPage}
							headerActions={headerActions}
							headerLeading={headerLeading}
							compact={isFullBleedPage}
						/>
					)}
					<div
						className={`${s.content} ${shouldShowHeader ? '' : s.wihoutHeader} ${
							isFullBleedPage ? s.contentApplicationDetails : ''
						}`}
					>
						<div
							className={`${
								shouldShowHeader && !isFullBleedPage
									? s.content__card
									: s.content__inner
							}`}
						>
							<Outlet />
						</div>
					</div>
				</div>

				<div className={s.footer}>
					<BottomBar />
				</div>
			</div>

			{/* KODA AI Chat Widget - floating on all dashboard pages */}
			<ChatWidget />
			<NoteTakerShell />
			<NoteTakerDrawer />
		</HeaderActionsContext.Provider>
	)
}
